import React from "react";
import { Link } from "react-router-dom";
import { Ghost } from "lucide-react";

/**
 * Sitewide Halloween capsule banner — pumpkin orange on near-black with a
 * subtle flicker. Links to the Halloween filter on the shop page.
 */
export const HalloweenBanner = () => (
  <Link
    to="/shop?halloween=true"
    data-testid="halloween-banner"
    className="relative block overflow-hidden border-b border-orange-900/40 bg-[#0a0806] group"
  >
    {/* ambient glow */}
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0"
      style={{
        background:
          "radial-gradient(ellipse at 20% 50%, rgba(234,88,12,0.22), transparent 55%), radial-gradient(ellipse at 80% 50%, rgba(234,88,12,0.15), transparent 55%)",
      }}
    />
    <div className="relative max-w-7xl mx-auto flex items-center justify-center gap-3 sm:gap-5 py-2.5 px-4">
      <Ghost
        className="w-4 h-4 text-orange-400 group-hover:text-orange-300 transition-colors animate-pulse"
        strokeWidth={2.2}
      />
      <span className="font-editorial font-semibold text-[11px] sm:text-xs uppercase tracking-[0.3em] text-orange-300 group-hover:text-orange-200 transition-colors">
        Halloween Capsule
      </span>
      <span className="hidden sm:inline text-orange-900/60">·</span>
      <span className="hidden sm:inline font-mono-tech text-[10px] uppercase tracking-[0.3em] text-orange-200/80">
        6 Haunted Pieces Live
      </span>
      <span className="text-orange-900/60">·</span>
      <span className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-orange-300 group-hover:text-orange-100 flex items-center gap-1 transition-colors">
        Shop Now <span aria-hidden="true" className="transition-transform group-hover:translate-x-0.5">→</span>
      </span>
    </div>
    {/* bottom flicker line */}
    <div
      aria-hidden="true"
      className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-orange-500/70 to-transparent"
    />
  </Link>
);

export default HalloweenBanner;
